module.exports = __webpack_public_path__ + "static/media/TaskManagement_admin_004.b1d01aa3.png";